import request from '@/utils/request';

// 创建人群
export function insertOrUpdateGroupAndRule(values) {
  return request('/profile/group/insertOrUpdateGroupAndRule', {
    method: 'POST',
    data: values,
  });
}

//人群详情
export function queryGroupAndRule(values) {
  return request('/profile/group/queryGroupAndRule', {
    method: 'POST',
    data: values,
  });
}

// 下载模版
export function downloadTemplate(values) {
  return request('/blacklist/downloadTemplate', {
    method: 'GET',
    data: values,
  });
}

// 字段列表
export function queryFileList(values) {
  return request('/profile/queryList', {
    method: 'POST',
    data: values,
  });
}

// 标签规则操作框的维度表数据
export function getQueryTagOperatorValue(values) {
  return request('/profile/tag/rule/queryTagOperatorValue', {
    method: 'POST',
    data: values,
  });
}

// 取值方式
export function queryTagBehaviorConditionList(values) {
  return request('/profile/tag/queryTagBehaviorConditionList', {
    method: 'POST',
    data: values,
  });
}

//树状标签
export function getTreeTags(values) {
  return request('/profile/tag/queryTagTree', {
    method: 'POST',
    data: values,
  });
}

// 删除标签
export function deleteLabel(values) {
  return request('/profile/deleteGroup', {
    method: 'POST',
    data: values,
  });
}

export function selectOption(values) {
  return request('/profile/tag/queryTagInfo', {
    method: 'POST',
    data: values,
  });
}

//预估
export function predict(values) {
  return request('/profile/group/groupPredict', {
    method: 'POST',
    data: values,
  });
}
